import React from "react";
import { Card } from "rebass";

const KEYS = [1, 2, 3];

const SIZE = 7;

export const HandleComponent = (
  <Card
    border="1px solid"
    borderColor="sp-gray"
    borderRadius="11px"
    bg="#fff"
    py={`${SIZE}px`}
    css="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); pointer-events: auto;"
  >
    {
      KEYS.map(key => (
        <Card
          key={key}
          width={`${SIZE}px`}
          height={`${SIZE}px`}
          m={`${0.5 * SIZE}px ${SIZE}px`}
          borderRadius="50%"
          bg="sp-gray"
        />
      ))
    }
  </Card>
);
